import { DataField } from "./DataField";
import { LinkProtocol } from "./LinkProtocol";

export abstract class LinkDataField extends DataField {

	public hasLink: boolean = false;
	public availableProtocols?: LinkProtocol[];

	public static isLinkField(field: DataField): field is LinkDataField {

		// Return Whether Field Is LinkDataFieldField
		return (field as LinkDataField).hasLink !== undefined;
	}
}
